// @flow
export const SET_MOBILE_SUMMARY_VISIBILITY = "bookingPayment/SET_MOBILE_SUMMARY_VISIBILITY"
export const ADDITIONAL_SERVICE_ORDER_SUCCESS = "bookingPayment/ADDITIONAL_SERVICE_ORDER_SUCCESS"
export const SET_SERVICE_ID_FOR_PAYMENT = "bookingPayment/SET_SERVICE_ID_FOR_PAYMENT"
export const SUBMIT_FOR_PAYMENT = "bookingPayment/SUBMIT_FOR_PAYMENT"
export const SET_CARD_TYPE_ACTION = "SET_CARD_TYPE"
